import {combineReducers} from 'redux';

import singleAlert from './singleAlert';
import alertsList  from './alertsList';
import alertListFilter from './alertListerFilter';
import latestAlert from './latestAlert';
import obsStatus from './obsStatus';

const combinedReducers = combineReducers({
	alertsList,
	alertListFilter,
	latestAlert,
	singleAlert,
	obsStatus,
});

export default combinedReducers; 